export enum CalculatorStepValue {
  SelectIndustry = 'industry',
  SelectProgram = 'program',
  SelectRiskPeriod = 'riskPeriod',
  SelectLocation = 'location',
  SelectOptionsTerm = 'optionsTerm',
  SelectClient = 'client',
  Review = 'review',
}
